'use client'

import type { Data } from '@repo/strapi-types'
import { useState } from 'react'
import { FeatureRoadmapDesktop } from '@/components/page-builder/global/featureRoadmap/FeatureRoadmapDesktop'
import { FeatureRoadmapMobile } from '@/components/page-builder/global/featureRoadmap/FeatureRoadmapMobile'
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'

type FeatureRoadmapClientProps = {
	readonly categories: Data.Component<'shared.roadmap-category'>[]
	readonly primaryColumnTitle: string
	readonly secondaryColumnTitle: string
}

export function FeatureRoadmapClient({
	categories,
	primaryColumnTitle,
	secondaryColumnTitle,
}: FeatureRoadmapClientProps) {
	const [activeTab, setActiveTab] = useState(primaryColumnTitle)

	return (
		<>
			{/* Desktop Version - Two Column Layout */}
			<FeatureRoadmapDesktop
				categories={categories}
				primaryColumnTitle={primaryColumnTitle}
				secondaryColumnTitle={secondaryColumnTitle}
			/>

			{/* Mobile Version - Tabs */}
			<div className="lg:hidden">
				<Tabs value={activeTab} onValueChange={setActiveTab} className="w-full">
					<div className="flex justify-center mb-6">
						<TabsList className="w-fit">
							<TabsTrigger value={primaryColumnTitle}>{primaryColumnTitle}</TabsTrigger>
							<TabsTrigger value={secondaryColumnTitle}>{secondaryColumnTitle}</TabsTrigger>
						</TabsList>
					</div>

					<TabsContent value={primaryColumnTitle}>
						<FeatureRoadmapMobile categories={categories} column="primary" />
					</TabsContent>

					<TabsContent value={secondaryColumnTitle}>
						<FeatureRoadmapMobile categories={categories} column="secondary" />
					</TabsContent>
				</Tabs>
			</div>
		</>
	)
}
